import { Avatar, Button, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import { FileOpen } from "@mui/icons-material";
import { Container } from "@mui/material/node";

export const PublicProjectItem = (props) => {
    return (
        <ListItem
            key={props.project.id}
            disableGutters
        >
            <ListItemAvatar >
                <Avatar alt="Project">
                    <FamilyRestroomIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={props.project.name} secondary={<>{props.project.description}<Container>Owner: <Typography variant="title">asdsa</Typography> </Container></>} />
            <Button variant="contained" component="a" href={`/p/${props.project.id}`}  startIcon={<FileOpen />}>
                Open
            </Button>
        </ListItem>
    );
};